// Fonction pour capitaliser la première lettre
export const capitalize = (str) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Fonction pour afficher les premiers caractères 
// de chaque ligne de commentaires
export const getCommentStarts = (text) => {
  // Utiliser une expression régulière pour trouver les débuts des lignes
  const regex = /^[^\n]{1,20}/gm; // Trouve les 20 premiers caractères de chaque ligne
  const matches = text.match(regex);

  // Joindre les débuts des commentaires en une seule ligne
  return matches ? matches.join(' | ') : '';
}